import { Card, CardContent } from '@/components/ui/card';
import { Users } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

const Stat = ({ label, value, sub, accent }) => (
  <div className="bg-card border border-border rounded-sm p-4">
    <p className="text-xs text-muted-foreground mb-1">{label}</p>
    <p className={`text-2xl font-bold font-mono ${accent || ''}`}>{value}</p>
    {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
  </div>
);

export const ParentEngagementCard = ({ engagement }) => {
  const { t } = useLanguage();
  if (!engagement) return null;
  const {
    total_parents,
    purchasing_parents,
    parent_purchase_rate,
    orders_per_parent,
    orders_per_purchasing_parent,
    avg_children_per_purchasing_parent,
  } = engagement;

  return (
    <Card className="bg-card border-border mb-10" data-testid="parent-engagement-card">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-1">
          <Users className="w-5 h-5 text-primary" />
          <h3 className="text-lg font-bold">{t('analytics.parentEngagementTitle')}</h3>
        </div>
        <p className="text-sm text-muted-foreground mb-6">{t('analytics.parentEngagementDesc')}</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Stat
            label={t('analytics.purchaseRate')}
            value={`${parent_purchase_rate}%`}
            sub={`${purchasing_parents} / ${total_parents} ${t('analytics.parentsLowercase')}`}
            accent="text-primary"
          />
          <Stat
            label={t('analytics.ordersPerParent')}
            value={orders_per_parent}
            sub={t('analytics.ordersPerParentSub')}
          />
          <Stat
            label={t('analytics.ordersPerActiveParent')}
            value={orders_per_purchasing_parent}
            sub={t('analytics.ordersPerActiveParentSub')}
          />
          <Stat
            label={t('analytics.childrenPerActiveParent')}
            value={avg_children_per_purchasing_parent}
            sub={t('analytics.childrenPerActiveParentSub')}
          />
        </div>
      </CardContent>
    </Card>
  );
};
